import type { AppRouter } from '@bitbot/backend/types';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import {
  createTRPCProxyClient,
  createTRPCReact,
  httpLink,
} from '@trpc/react-query';
import React, { useState } from 'react';
import { TRPC_URL } from '../config';
import superjson from 'superjson';

let _jwtToken = '';
export const setJwtToken = (token: string) => {
  _jwtToken = token;
};

export const trpc = createTRPCReact<AppRouter>();

export const trpcApi = createTRPCProxyClient<AppRouter>({
  transformer: superjson,
  links: [
    httpLink({
      url: TRPC_URL,
      headers() {
        return {
          authorization: `Bearer ${_jwtToken}`,
        };
      },
    }),
  ],
});

export const TRPCProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: { retry: false, refetchOnWindowFocus: false },
        },
      }),
  );
  const [trpcClient] = useState(() =>
    trpc.createClient({
      transformer: superjson,
      links: [
        httpLink({
          url: TRPC_URL,
          headers() {
            return {
              authorization: `Bearer ${_jwtToken}`,
            };
          },
        }),
      ],
    }),
  );

  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>
        {children}
      </QueryClientProvider>
    </trpc.Provider>
  );
};
